import React from "react";

import { FaHeart, FaBars } from "react-icons/fa";
//import reactLogo from "./assets/logo.svg"

import Homepage from "../../../container/HomePage/HomePage";

import About from "../../../container/About/About";
import axios from "axios";
import urldata from "../../../urldata";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

// components
import JobApplyModel from "../../../component/JobApplyModel/JobApplyModel";
import JobApplication from "../Views/career/JobApplication";
import Jobpostlist from "../Views/career/Jobpostlist";
import ContactUsFormList from "../Views/contact_us/ContactUsFormList";
import CollaborateFormList from "../Views/collaborate/CollaborateFormList";
import NewsLetter from "../Views/NewsLetter";
import CvUpload from "../Views/career/CvUpload";
import HomepageBannerList from "../Views/homepage/HomepageBannerList";
import HomepageAboutSec1 from "../Views/homepage/HomepageAboutSec1";
import HomepageProducts from "../Views/homepage/HomepageProducts";
import HomepageFAQ from "../Views/homepageFAQ/HomepageFAQ";
import FooterSocial from "../Views/footer/FooterSocialMedia";
import HomepageRedBanner from "../Views/homepageRedBanner/HomepageRedBanner";
import HomepageBlogs from "../Views/homepage/HomepageBlogs";
import HomepageLaxmiKitchen from "../Views/homepage/HomepageLaxmiKitchen";
import AddOurPartners from "../Views/our_brands/AddOurPartners";
import PressRelease from "../Views/media/PressRelease";
import TvAds from "../Views/media/TvAds";
import AboutUsBanner from "../Views/about_us/AboutUsBanner";
import OurBrandsBanner from "../Views/our_brands/OurBrandsBanner";
//import MediaBanner from "../Views/media/MediaBannerOld";
import CollaborateBanner from "../Views/collaborate/CollaborateBanner";
import CareerBanner from "../Views/career/CareerBanner";
import CareerSubBanner from "../Views/career/CareerSubBanner";
import ContactBanner from "../Views/contact_us/ContactBanner";
import ContactusBanner from "../Views/contact_us/ContactusBanner";
import ContactusForm from "../Views/contact_us/ContactusForm";
import OurJourney from "../Views/homepage/OurJourney";
import LaxmiWorld from "../Views/homepage/LaxmiWorld";
import LaxmiWorld2 from "../Views/homepage/LaxmiWorld2";
import BlogList from "../Views/blogs/BlogList";
import BlogBanner from "../Views/blogs/BlogBanner";
import LaxmisKitchenBanner from "../Views/laxmisKitchen/LaxmisKitchenBanner";
import LaxmisKitchenRecipesList from "../Views/laxmisKitchen/LaxmisKitchenRecipesList";
import MediaBanner from "../Views/media/MediaBanner";
import MediaVideo from "../Views/media/MediaVideo";
import OurStoryBanner from "../Views/ourStory/OurStoryBanner";
import OurStoryWelcome from "../Views/ourStory/OurStoryWelcome";
import OurStoryVisionMisison from "../Views/ourStory/OurStoryVisionMisison";
import OurStoryMilestones from "../Views/ourStory/OurStoryMilestones";
import OurStoryLaxmiPromise from "../Views/ourStory/OurStoryLaxmiPromise";
import ProductCategory from "../Views/ProductCategory/Index";
import ProductCategories from "../Views/products/ProductCategories";
import ProductSubCategories from "../Views/products/ProductSubCategories";
import Products from "../Views/products/Products";
import Stores from "../Views/stores/Stores";
import StoresBrands from "../Views/stores/Brands";
import StoresBanner from "../Views/stores/Banner";
import ProductBanner from "../Views/products/ProductBanner";
import ProductUnits from "../Views/products/ProductUnits";
import OurPresence from "../Views/contact_us/OurPresence";
import GetInTouch from "../Views/contact_us/GetInTouch";
import ContactusDetails from "../Views/contact_us/ContactusDetails";
import OurPartnerBrands from "../Views/our_brands/OurPartnerBrands";
import CollaborateSecTwo from "../Views/collaborate/CollaborateSecTwo";
import CollaborateSecThree from "../Views/collaborate/CollaborateSecThree";
import Brands from "../Views/our_brands/Brands";
import AboutUsSecTwo from "../Views/about_us/AboutUsSecTwo";
import AboutUsSecThree from "../Views/about_us/AboutUsSecThree";
import AboutUsSecFour from "../Views/about_us/AboutUsSecFour";
// import CareerSecTwo from "../Views/career/CareerSecTwo";
import OurProductBrands from "../Views/our_brands/OurProductBrands";
import OurBrandDesc from "../Views/homepage/OurBrandDesc";
import OurPartnerBrandDesc from "../Views/homepage/OurPartnerBrandDesc";
import InHouseBrandDesc from "../Views/our_brands/InHouseBrandDesc";
import OurPartBrandDesc from "../Views/our_brands/OurPartBrandDesc";
import FooterContent from "../Views/footer/FooterContent";
import PrivacyPolicyBanner from "../Views/privacy_policy/PrivacyPolicyBanner";
import PolicyDetails from "../Views/privacy_policy/PolicyDetails";
import AddPdf from "../Views/pdfpage/AddPdf";
import FooterSocialMedia from "../Views/footer/FooterSocialMedia";
import LandingPageForm from "../Views/leads/LandingPage";
import DiwaliBonanza from "../Views/leads/DiwaliBonanza";
import DiwaliBonanzaWinners from "../Views/diwaliBonanza/Winners";
import DiwaliBonanzaDashboard from "../Views/diwaliBonanza/Dashboard";
import LaxmiPackagingSurvey2026 from "../Views/leads/PackagingSurvey";
import GrocerySurvey from "../Views/leads/GrocerySurvey";

import DiwaliBonanza2025 from "../Views/leads/DiwaliBonanza2025";
import DiwaliBonanza2026 from "../Views/leads/DiwaliBonanza2026";
import DiwaliBonanzaWinners2025 from "../Views/diwaliBonanza2025/Winners";

import DiwaliBonanzaDailyWinners2025 from "../Views/leads/DiwaliBonanzaDailyWinners2025";
import DiwaliBonanza2026DailyWinnerGenerate from "../Views/leads/DiwaliBonanza2026DailyWinnerGenerate";
import DiwaliBonanza2026DailyWinners from "../Views/leads/DiwaliBonanza2026DailyWinners";
import DiwaliBonanza2026MonthlyWinners from "../Views/leads/DiwaliBonanza2026MonthlyWinners";
import DiwaliBonanza2026MonthlyVerifiedWinners from "../Views/leads/DiwaliBonanza2026MonthlyVerifiedWinners";

import HomepageSlider from "../Views/HomepageSlider/Index";
import FaqIndex from "../Views/FAQ/index";
import ProductContent from "../Views/ProductContent/Index";
import HeaderLogo from "../Views/Logo/Index"
import LaxmisKitchenIndex from "../Views/laxmisKitchen/MoreRecipeVideo/index.jsx";
import MoreRecipeVideoIndex from "../Views/laxmisKitchen/Categories/Index.jsx";
// >>>>>>> 1af93315e62524c67afc136e836b9eac17cefe62ourstoryvisionmission

const Main = ({
  collapsed,
  rtl,
  image,
  handleToggleSidebar,
  handleCollapsedChange,
  handleRtlChange,
  handleImageChange,
  history,
}) => {
  const logoutBtnClick = (id) => {
    let url = new URL(urldata + "admin/logout");
    console.log("logged out");
    localStorage.clear();
    history.push("/admin/");
  };
  return (
    <main>
      <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
        <FaBars />
      </div>
      <header className="d-f jc-sb a-c">
        <p className="c-p" onClick={() => history.push("/admin/dashboard/")}>
          Dashboard
        </p>
        <div
          className="logout_btn c-p"
          onClick={() => {
            logoutBtnClick();
          }}
        >
          Logout
        </div>
      </header>

      <>
        <div className="dashboardDataContainer">
          <Switch>
            {/* homepage routes */}
            <Route
              exact
              path="/admin/dashboard/aboutussectwo"
              component={AboutUsSecTwo}
            />
            <Route
              exact
              path="/admin/dashboard/ourbranddesc"
              component={OurBrandDesc}
            />
            <Route
              exact
              path="/admin/dashboard/homepageproducts"
              component={HomepageProducts}
            />
            <Route
              exact
              path="/admin/dashboard/homepage/faq"
              component={HomepageFAQ}
            />
            <Route
              exact
              path="/admin/dashboard/footer/social"
              component={FooterSocial}
            />
            <Route
              exact
              path="/admin/dashboard/footer/content"
              component={FooterContent}
            />
            <Route
              exact
              path="/admin/dashboard/homepage/findastoresection"
              component={HomepageRedBanner}
            />
            <Route
              exact
              path="/admin/dashboard/homepagelaxmikitchen"
              component={HomepageLaxmiKitchen}
            />
            <Route
              exact
              path="/admin/dashboard/homepageblogs"
              component={HomepageBlogs}
            />
            <Route
              exact
              path="/admin/dashboard/laxmiworld"
              component={LaxmiWorld}
            />
            <Route
              exact
              path="/admin/dashboard/bloglist"
              component={BlogList}
            />
            <Route
              exact
              path="/admin/dashboard/blogbanner"
              component={BlogBanner}
            />
            <Route
              exact
              path="/admin/dashboard/laxmisrecipebanner"
              component={LaxmisKitchenBanner}
            />
            {/* <Route
              exact
              path="/admin/dashboard/laxmiskitchenrecipes"
              component={LaxmisKitchenRecipesList}
            /> */}
            <Route
              exact
              path="/admin/dashboard/laxmisrecipes"
              component={LaxmisKitchenIndex}
            />
            <Route
              exact
              path="/admin/dashboard/laxmisrecipecategories"
              component={MoreRecipeVideoIndex}
            />
            <Route
              exact
              path="/admin/dashboard/contactusbanner"
              component={ContactusBanner}
            />
            <Route
              exact
              path="/admin/dashboard/contactusdetails"
              component={ContactusDetails}
            />
            <Route
              exact
              path="/admin/dashboard/contactusform"
              component={ContactusForm}
            />
            <Route
              exact
              path="/admin/dashboard/mediabanner"
              component={MediaBanner}
            />
            <Route
              exact
              path="/admin/dashboard/mediavideo"
              component={MediaVideo}
            />
            <Route
              exact
              path="/admin/dashboard/ourstorybanner"
              component={OurStoryBanner}
            />
            <Route
              exact
              path="/admin/dashboard/ourstorywelcome"
              component={OurStoryWelcome}
            />
            <Route
              exact
              path="/admin/dashboard/ourstoryvisionmission"
              component={OurStoryVisionMisison}
            />
            <Route
              exact
              path="/admin/dashboard/ourstorymilestones"
              component={OurStoryMilestones}
            />
            <Route
              exact
              path="/admin/dashboard/ourstorylaxmipromise"
              component={OurStoryLaxmiPromise}
            />
            {/* <Route
              exact
              path="/admin/dashboard/productcategory"
              component={ProductCategories}
            /> */}
            <Route
              exact
              path="/admin/dashboard/product-categories"
              component={ProductCategory}
            />
            <Route
              exact
              path="/admin/dashboard/productsubcategory"
              component={ProductSubCategories}
            />
            <Route
              exact
              path="/admin/dashboard/productunit"
              component={ProductUnits}
            />
            <Route
              exact
              path="/admin/dashboard/products"
              component={Products}
            />
            <Route
              exact
              path="/admin/dashboard/storesstores"
              component={Stores}
            />
            <Route
              exact
              path="/admin/dashboard/storesbrands"
              component={StoresBrands}
            />

            <Route
              exact
              path="/admin/dashboard/hompeagebannerlist"
              component={HomepageBannerList}
            />
            <Route
              exact
              path="/admin/dashboard/homepage/sliders"
              component={HomepageSlider}
            />
            <Route
              exact
              path="/admin/dashboard/faq/categories"
              component={FaqIndex}
            />
            <Route
              exact
              path="/admin/dashboard/storesbanner"
              component={StoresBanner}
            />
            <Route
              exact
              path="/admin/dashboard/productbanner"
              component={ProductBanner}
            />
            <Route
              exact
              path="/admin/dashboard/leads/landing-page"
              component={LandingPageForm}
            />
            <Route
              exact
              path="/admin/dashboard/leads/Laxmi-Packaging-Survey-2026"
              component={LaxmiPackagingSurvey2026}
            />
            <Route
              exact
              path="/admin/dashboard/leads/grocery-survey"
              component={GrocerySurvey}
            />
            <Route
              exact
              path="/admin/dashboard/leads/diwali-bonanza"
              component={DiwaliBonanza}
            />

            <Route
              exact
              path="/admin/dashboard/diwali-bonanza/winners"
              component={DiwaliBonanzaWinners}
            />

            {/* ================== DIWALI BONANZA 2025======================= */}
            <Route
              exact
              path="/admin/dashboard/leads/diwali-bonanza-2025"
              component={DiwaliBonanza2025}
            />

            <Route
              exact
              path="/admin/dashboard/diwali-bonanza-2025/winners"
              component={DiwaliBonanzaWinners2025}
            />

            <Route
              exact
              path="/admin/dashboard/leads/diwali-bonanza-2025/daily-winners"
              component={DiwaliBonanzaDailyWinners2025}
            />

            <Route
              exact
              path="/admin/dashboard/diwali-bonanza/dashboard"
              component={DiwaliBonanzaDashboard}
            />

            {/* ================== DIWALI BONANZA 2026======================= */}
            <Route
              exact
              path="/admin/dashboard/leads/dream-big-win-bigger-2026"
              component={DiwaliBonanza2026}
            />

            <Route
              exact
              path="/admin/dashboard/leads/dream-big-win-bigger-2026/generate-daily-winners"
              component={DiwaliBonanza2026DailyWinnerGenerate}
            />

            <Route
              exact
              path="/admin/dashboard/leads/dream-big-win-bigger-2026/daily-winners"
              component={DiwaliBonanza2026DailyWinners}
            />

            <Route
              exact
              path="/admin/dashboard/leads/dream-big-win-bigger-2026/generate-monthly-winners"
              component={DiwaliBonanza2026MonthlyWinners}
            />

            <Route
              exact
              path="/admin/dashboard/leads/dream-big-win-bigger-2026/monthly-winners"
              component={DiwaliBonanza2026MonthlyVerifiedWinners}
            />

            <Route
              exact
              path="/admin/dashboard/product/content"
              component={ProductContent}
            />

            <Route
              exact
              path="/admin/dashboard/header/logo"
              component={HeaderLogo}
            />

            <Redirect to="/admin/dashboard/" />
          </Switch>
        </div>
      </>

      <footer></footer>
    </main>
  );
};

export default Main;
